import type { VisState } from '@carto/kepler.gl'
import type { CartoKeplerMapConfigEnvelope } from 'features/maps/types'
import { LayerPopupSettings } from '../types'

/**
 * Removes layer configurations associated with an AI Agent from the map config, to prevent
 * these temporary layers from being auto-saved.
 */
export function removeAgentLayersFromMapConfig(
  localKeplerConfig: CartoKeplerMapConfigEnvelope,
  agentLayerIds: string[]
) {
  if (agentLayerIds.length === 0) {
    return localKeplerConfig
  }

  const { config } = localKeplerConfig

  // Exclude AI-generated layers.
  const layerIdSet = new Set(config.visState.layers.map((l) => l.id))
  const agentLayerIdSet = new Set(agentLayerIds)
  const layersToSave: VisState['layers'] = config.visState.layers.filter((l) => !agentLayerIdSet.has(l.id))

  // Exclude AI-generated layer popup settings.
  const datasetsToSave = new Set(layersToSave.map((l) => l.config.dataId))
  const fieldsToShowToSave = {}
  // @ts-expect-error TODO: Fix types after Kepler removal.
  for (const datasetId in config.visState.interactionConfig.tooltip.fieldsToShow) {
    if (datasetsToSave.has(datasetId)) {
      fieldsToShowToSave[datasetId] =
        // @ts-expect-error TODO: Fix types after Kepler removal.
        config.visState.interactionConfig.tooltip.fieldsToShow[datasetId]
    }
  }

  const layerPopupSettingsToSave: Record<string, LayerPopupSettings> = {}
  for (const layerId in config.popupSettings?.layers) {
    if (layerIdSet.has(layerId) && !agentLayerIdSet.has(layerId)) {
      layerPopupSettingsToSave[layerId] = config.popupSettings.layers[layerId]
    }
  }

  return {
    ...localKeplerConfig,
    config: {
      ...config,
      visState: {
        ...config.visState,
        layers: layersToSave,
        interactionConfig: {
          ...config.visState.interactionConfig,
          tooltip: {
            ...config.visState.interactionConfig.tooltip,
            fieldsToShow: fieldsToShowToSave
          }
        }
      },
      popupSettings: {
        ...config.popupSettings,
        layers: layerPopupSettingsToSave
      }
    }
  }
}
